var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInitialprocrutment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6016 1.67188H10.4297V0.5H4.57031V1.67188H3.39844C2.42918 1.67188 1.64062 2.46043 1.64062 3.42969V13.7422C1.64062 14.7114 2.42918 15.5 3.39844 15.5H11.6016C12.5708 15.5 13.3594 14.7114 13.3594 13.7422V3.42969C13.3594 2.46043 12.5708 1.67188 11.6016 1.67188ZM5.74219 1.67188H9.25781V2.25781C9.25781 2.5809 8.99496 2.84375 8.67188 2.84375H6.32812C6.00504 2.84375 5.74219 2.5809 5.74219 2.25781V1.67188ZM12.1875 13.7422C12.1875 14.0653 11.9246 14.3281 11.6016 14.3281H3.39844C3.07535 14.3281 2.8125 14.0653 2.8125 13.7422V3.42969C2.8125 3.1066 3.07535 2.84375 3.39844 2.84375H4.67109C4.91297 3.52572 5.56427 4.01562 6.32812 4.01562H8.67188C9.43573 4.01562 10.087 3.52572 10.3289 2.84375H11.6016C11.9246 2.84375 12.1875 3.1066 12.1875 3.42969V13.7422Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 6.24219H11.0156V7.41406H9.84375V6.24219Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 8.58594H11.0156V9.75781H9.84375V8.58594Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 10.9297H11.0156V12.1016H9.84375V10.9297Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98438 6.24219H8.67188V7.41406H3.98438V6.24219Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98438 8.58594H8.67188V9.75781H3.98438V8.58594Z",
    fill: "currentcolor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98438 10.9297H8.67188V12.1016H3.98438V10.9297Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "none",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitialprocrutment);
export default __webpack_public_path__ + "static/media/initialprocrutment.b3ed3f7da4634f020ffbcc9e6cb7c2b5.svg";
export { ForwardRef as ReactComponent };